import ChaptersContainer from './chapters_container';

const Chapters = ChaptersContainer;
export default Chapters;
